module.exports = __webpack_public_path__ + "static/media/YM87_1.7c709ff8.jpg";